import React from "react";
import "../App.css";
import Fire from "../config/Fire";
//import {InfiniteLoading} from 'react-simple-infinite-loading'
import InfiniteScroll from 'react-infinite-scroll-component';
import Aux from "../utils/AuxFunctions";
import { withMyDataContext } from "../context/DataProvider";
import Loader from "../utils/Utilities/Loader"
import ChevronLeftIcon from "mdi-react/ChevronLeftIcon";
import CheckIcon from "mdi-react/CheckCircleIcon";
import UncheckIcon from "mdi-react/CheckboxBlankCircleOutlineIcon";
import Colors from "../utils/Colors";

const LIMIT = 100;
const TITLE = "dummyUsers"

class AdminMain extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dummysData: [],
            lastVisible: null,
            finished: false,
            loading: false,
            selected: "",
        }
    }

     componentDidMount() {
        try {
            this.getAllData(true);
        } catch (error) {
            Aux.handleError(error)
        }
    }

    getAllData = async (isStart) => {
        if (this.state.loading) return;
        let lastVisible = null;

        if (isStart) {
            this.setState({
                dummysData: [],
                finished: false,
                lastVisible: null,
                refreshing: false,
            });
        } else {
            lastVisible = this.state.lastVisible
        }

        try {
            this.setState({ loading: true })
            Fire.shared
                .GetPostsData(TITLE, lastVisible, LIMIT)
                .then(snapshot => {
                    if (snapshot) {

                        if (snapshot.length < LIMIT || snapshot.empty) {
                            this.setState({ finished: true })
                        }

                        let data = snapshot.docs.map(document => {
                            const doc = document.data();
                            doc.id = document.id;
                            return doc;
                        });

                        this.setState({
                            dummysData: [...this.state.dummysData, ...data],
                            lastVisible: snapshot.docs[snapshot.docs.length - 1],
                            loading: false,
                        });

                    } else {
                        this.setState({ finished: true, loading: false })
                    }
                });
        } catch (error) {
            Aux.handleError(error);
        }
    };


    goBack = () => {
        try{
            this.props.history.goBack()
        }catch(error){
            Aux.handleError(error)
        }
    }

    goToCreateDummy = () => {
        try{
            this.props.history.push("/admin/add")
        }catch(error){
            Aux.handleError(error)
        }
    }

    onSelectItem = (user) => {
        if (user.id !== this.state.selected) {
            Fire.shared.setDummyCurrentUser(user)
            this.setState({ selected: user.id})
            this.props.myDataProvider.updateUserDummy(user)
        }
    }

    removeCurrentUser = () => {
        var saveUser = Fire.shared.deleteDummyUser();
        this.setState({ selected: ""})
        this.props.myDataProvider.updateUserDummy(saveUser);
    }

    RenderDummyItem = (props) => {
        return (
            <div style={{display:"flex", margin: 15, alignItems: "center" }} className="button-hover"
                onClick={() => this.onSelectItem(props.item)}>
                {this.state.selected === "check-circle" ?
                <CheckIcon></CheckIcon> :
                <UncheckIcon></UncheckIcon> }
                {/* <Icon size={30} name={item.id === this.state.selected ? "check-circle" : "checkbox-blank-circle-outline"}
                    style={{ color: item.id === this.state.selected ? Colors.mainColor : "#ccc", marginRight: 20 }}>
                </Icon> */}
                {Aux.showAvatar(30, props.item.avatar, props.item.username || "Unknown")}
                <span style={{marginLeft:10}}>{props.item.username || props.item.name}</span>
            </div>
        )
    }

    render() {

        return (
            <div style={{width:"100%"}}>
                <section className="container" >
                <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                    <div className="reversed-button-hover" style={{display:"flex", alignItems:"center", marginBottom:20}} onClick={this.goBack}>
                        <ChevronLeftIcon style={{marginRight:5}}></ChevronLeftIcon>
                        <h2>Admin</h2>
                    </div>
                    <div style={{display:"flex"}}>
                        {Fire.shared.isDummy ? 
                        <div onClick={this.removeCurrentUser} style={{marginRight:10}} className="button-hover">
                            <span style={{color:"#red"}}>Revert</span>
                        </div> : null}
                        <div onClick={this.goToCreateDummy} className="button-hover">
                            <span style={{color:Colors.mainColor}}>Add</span>
                        </div>
                    </div>
                </div>
                {/*{this.props.myDataProvider.messagesData.length <= 0 ? 
                        <div style={{display:"flex", justifyContent:"center"}}>
                            <span style={{marginTop:20}}>You've got no messages yet...</span>
                        </div> :
                  this.props.myDataProvider.messagesData.map((item, index) => (
                            <SingleMessage message={item} key={item.id + index}></SingleMessage>
                    ))} */}
                    {this.props.myDataProvider.user?.role === "admin" ?
             <InfiniteScroll
                    //style={{backgroundColor:"#ECEFF1", minHeight:"86vh"}}
                    dataLength={this.state.dummysData}
                    next={this.getAllData}
                    scrollableTarget="sideBar"
                    hasMore={!this.state.finished}
                    initialScrollY={0}
                    loader={<div style={{marginTop:20}}><Loader color={"#999"}></Loader></div>}
                    endMessage={
                        <div style={{marginTop:20}}>
                            {this.state.dummysData.length === 0 ?
                            <p style={{ textAlign: 'center' }}>
                                <b>there are no dummy users.</b>
                            </p>
                            :
                            <p style={{ textAlign: 'center' }}>
                                <b>You have seen it all.</b>
                            </p>}
                        </div>
                    }
                > 
                    {this.state.dummysData.map((item, index) => (
                        <this.RenderDummyItem item={item} key={index}></this.RenderDummyItem>
                    ))}
                </InfiniteScroll> : 
                <div style={{display:"flex", justifyContent:"center", alignItems:"center", margin: "20px 0"}}>
                        <span>You're not an admin</span>
                    </div>}
                </section>
            </div>
        );
    }
}

export default withMyDataContext(AdminMain);